var React = require('react');

function TickInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M5.546 10.705l7.771-9.357 1.83 1.515-9.601 11.5L0 9.483l1.647-2.054z"}));
}

TickInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = TickInline;

TickInline.default = TickInline;
